import PhotoDetailDialog from './PhotoDetailDialogContainer';

export default PhotoDetailDialog;
